import { Converter } from '../types/converter';

export const heatFluxDensityConverter: Converter = {
  id: 'heatFluxDensity',
  name: 'Heat Flux Density Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // SI base unit and derivatives
    { name: 'Watt/Square Meter', symbol: 'W/m²', factor: 1 },
    { name: 'Kilowatt/Square Meter', symbol: 'kW/m²', factor: 1000 },
    { name: 'Watt/Square Centimeter', symbol: 'W/cm²', factor: 10000 },
    { name: 'Watt/Square Inch', symbol: 'W/in²', factor: 1550.003100006 },
    { name: 'Joule/Second/Square Meter', symbol: 'J/(s·m²)', factor: 1 },

    // Calorie-based units
    { name: 'Kilocalorie (IT)/Hour/Square Meter', symbol: 'kcal (IT)/(h·m²)', factor: 1.163 },
    { name: 'Kilocalorie (IT)/Hour/Square Foot', symbol: 'kcal (IT)/(h·ft²)', factor: 0.1080486 },
    { name: 'Calorie (IT)/Second/Square Centimeter', symbol: 'cal (IT)/(s·cm²)', factor: 41868 },
    { name: 'Calorie (IT)/Minute/Square Centimeter', symbol: 'cal (IT)/(min·cm²)', factor: 697.8 },
    { name: 'Calorie (IT)/Hour/Square Centimeter', symbol: 'cal (IT)/(h·cm²)', factor: 11.63 },
    { name: 'Calorie (th)/Second/Square Centimeter', symbol: 'cal (th)/(s·cm²)', factor: 41840 },
    { name: 'Calorie (th)/Minute/Square Centimeter', symbol: 'cal (th)/(min·cm²)', factor: 697.333333 },
    { name: 'Calorie (th)/Hour/Square Centimeter', symbol: 'cal (th)/(h·cm²)', factor: 11.622222 },

    // CGS units
    { name: 'Dyne/Hour/Centimeter', symbol: 'dyn/(h·cm)', factor: 2.777778e-7 },
    { name: 'Erg/Hour/Square Millimeter', symbol: 'erg/(h·mm²)', factor: 2.777778e-7 },

    // Imperial/US units
    { name: 'Foot Pound/Minute/Square Foot', symbol: 'ft·lbf/(min·ft²)', factor: 0.04214011 },
    { name: 'Horsepower/Square Foot', symbol: 'hp/ft²', factor: 2544.433921 },
    { name: 'Horsepower (Metric)/Square Foot', symbol: 'hp (metric)/ft²', factor: 2510.6845 },

    // BTU-based units
    { name: 'Btu (IT)/Second/Square Foot', symbol: 'Btu (IT)/(s·ft²)', factor: 11356.53 },
    { name: 'Btu (IT)/Minute/Square Foot', symbol: 'Btu (IT)/(min·ft²)', factor: 189.2755 },
    { name: 'Btu (IT)/Hour/Square Foot', symbol: 'Btu (IT)/(h·ft²)', factor: 3.154592 },
    { name: 'Btu (th)/Second/Square Inch', symbol: 'Btu (th)/(s·in²)', factor: 1635846.72 },
    { name: 'Btu (th)/Second/Square Foot', symbol: 'Btu (th)/(s·ft²)', factor: 11348.93 },
    { name: 'Btu (th)/Minute/Square Foot', symbol: 'Btu (th)/(min·ft²)', factor: 189.1488 },
    { name: 'Btu (th)/Hour/Square Foot', symbol: 'Btu (th)/(h·ft²)', factor: 3.152480 },
    { name: 'CHU/Hour/Square Foot', symbol: 'CHU/(h·ft²)', factor: 5.678263 }
  ]
};
